import React from "react";
import { Amount } from "./support_sales_widgets";

function saleDate(value, consultation) {
  if (!value) return consultation ? "زمان مشاوره نامشخص" : "تاریخ خرید نامشخص";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return consultation ? "زمان مشاوره نامشخص" : "تاریخ خرید نامشخص";
  return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    year: "numeric", month: "2-digit", day: "2-digit", timeZone: "Asia/Tehran",
    ...(consultation ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
}

export default function SaleRows({ entries, title, consultation = false }) {
  if (!Array.isArray(entries)) {
    return <p className="px-3 py-3 text-xs leading-6 text-app-text-muted">جزئیات فروش در دسترس نیست.</p>;
  }
  if (entries.length === 0) {
    return <p className="px-3 py-3 text-xs leading-6 text-app-text-muted">{consultation ? "مشاوره‌ای" : "خدمتی"} در این بازه ثبت نشده است.</p>;
  }
  return (
    <ol aria-label={`${title} - فهرست`} tabIndex={0} className="max-h-56 divide-y divide-app-border overflow-y-auto overscroll-contain rounded-b-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-app-focus">
      {entries.map((entry) => {
        const date = consultation ? entry.scheduled_at : entry.paid_at;
        const customerName = entry.customer_name?.trim() || "کاربر نامشخص";
        const agentName = entry.agent_name?.trim() || "مباشر نامشخص";
        const initials = customerName.split(/\s+/).slice(0, 2).map((word) => Array.from(word)[0]).join("");
        return (
          <li key={entry.id} className={`flex items-start gap-2 border-s-2 px-3 py-2.5 transition-colors ${consultation ? "border-teal-500 bg-teal-500/[0.025] hover:bg-teal-500/5" : "border-blue-500 bg-blue-500/[0.025] hover:bg-blue-500/5"}`}>
            <span aria-hidden="true" className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold ${consultation ? "bg-teal-500/10 text-teal-600" : "bg-blue-500/10 text-blue-600"}`}>
              {initials}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-start justify-between gap-x-2 gap-y-1">
                <p className="min-w-0 flex-1 break-words text-xs font-semibold leading-5 text-app-text">
                  <bdi>{customerName}</bdi>{" با "}<bdi>{agentName}</bdi>
                </p>
                <Amount value={entry.amount} className="shrink-0 rounded-md border border-app-border bg-app-surface px-2 py-1 text-[11px] font-semibold text-app-text" />
              </div>
              <time dateTime={date || undefined} title={consultation ? "زمان مشاوره" : "تاریخ خرید"} className="mt-0.5 block text-[11px] leading-5 tabular-nums text-app-text-muted">
                {saleDate(date, consultation)}
              </time>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
